// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0bcf9a27","89":"2e18b8ad","944":"d9d4e41b"}[chunkId] + ".chunk.js";
};